import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import Image from 'next/image'

import { REDUCED_MOTION } from '@/lib/motion'
import { FRAMES } from '@/constants/frames'

const REEL = ['coast-road', 'moon-over-cone', 'turquoise-tarn', 'meadow-boulders']
    .map((id) => FRAMES.find((frame) => frame.id === id))
    .filter((frame): frame is (typeof FRAMES)[number] => Boolean(frame))

const HOLD = 3400

/**
 * The archive, walking itself. Each frame is SET rather than dissolved:
 * it wipes up from the bottom edge the way a print is placed on the
 * wall, which keeps the About page speaking the same language as the
 * hang on the home page.
 */
export const AboutReel: FC = (): ReactNode => {
    const [index, setIndex] = useState(0)

    useEffect(() => {
        if (window.matchMedia(REDUCED_MOTION).matches) return

        const timer = setInterval(() => {
            setIndex((current) => (current + 1) % REEL.length)
        }, HOLD)

        return () => clearInterval(timer)
    }, [])

    const active = REEL[index]

    return (
        <div>
            <div className='ab-reel aspect-[4/5]' data-reveal='mask' data-parallax='40'>
                {REEL.map((frame, position) => (
                    <div
                        key={frame.id}
                        className='ab-reel-frame'
                        data-active={position === index}
                    >
                        <Image
                            src={frame.image}
                            alt={position === index ? `${frame.title}, ${frame.location}` : ''}
                            fill
                            sizes='(max-width: 767px) 100vw, 42vw'
                            quality={82}
                            priority={position === 0}
                            loading={position === 0 ? undefined : 'eager'}
                            style={{ objectFit: 'cover', objectPosition: frame.focus }}
                        />
                    </div>
                ))}
            </div>

            <div className='mt-5 flex items-center justify-between gap-6' data-reveal='up'>
                <div className='ed-mono text-faint'>
                    {active.title} · {active.location}
                </div>

                <div className='ab-tick' aria-hidden>
                    {REEL.map((frame, position) => (
                        <span key={frame.id} data-active={position === index} />
                    ))}
                </div>
            </div>
        </div>
    )
}
